// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- HS Code
import { RespondentTokenValidationModel, RespondentValidationStages } from '../../../models';
import { OidcService } from '../account/oidc.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class RespondentValidationBaseService {

  protected _validationStage$: BehaviorSubject<RespondentValidationStages>;
  get validationStage$(): Observable<RespondentValidationStages> {
    return this._validationStage$;
  }

  protected _respondentValidation$: BehaviorSubject<RespondentTokenValidationModel | null>;
  get respondentValidation$(): Observable<RespondentTokenValidationModel | null> {
    return this._respondentValidation$;
  }

  constructor(protected oidcService: OidcService) {
    this._validationStage$ = new BehaviorSubject<RespondentValidationStages>(RespondentValidationStages.validatingToken);
    this._respondentValidation$ = new BehaviorSubject<RespondentTokenValidationModel | null>(null);
  }

  protected _authenticateFromOtac(otac: string) {
    this._validationStage$.next(RespondentValidationStages.authenticating);
    this.oidcService.signInRedirect({
      extraQueryParams: {
        acr_values: 'otac:' + otac
      }
    });
  }

  abstract validateRespondentToken(id: string): void;
}
